import { BreakpointsOptions } from "@mui/material/styles";

declare module "@mui/system" {
    interface BreakpointOverrides {
        xsMobile: true;
        tablet: true;
        "2xl": true;
        "3xl": true;
        "4xl": true;
        "5xl": true;
    }
}

export const breakpoints: BreakpointsOptions = {
    values: {
        xsMobile: 0,
        xs: 370,
        tablet: 550,
        sm: 768,
        md: 1023,
        lg: 1280,
        xl: 1920,
        "2xl": 2560,
        "3xl": 3200,
        "4xl": 4200,
        "5xl": 5120,
    },
};
